export const FILE_SIZE_BYTES = 10 * 1024 * 1024; // 10MiB
